import React from "react";
import { TabPanel, TabView } from "primereact/tabview";
import { ITab } from "../../interface/tab";

interface IREITabProps {
  id?: string;
  testId?: string;
  tabs: ITab[];
  classNames?: string;
  tabViewClassNames?: string;
  handleTabClose?: (e: any) => void;
  activeIndex?: number;
  onTabChange?: (e: { index: number }) => void;
}

const REITab: React.FC<IREITabProps> = ({
  id,
  testId,
  tabs,
  tabViewClassNames,
  classNames,
  handleTabClose,
  activeIndex,
  onTabChange,
}) => {
  return (
    <TabView
      id={id}
      data-testid={testId ?? id}
      activeIndex={activeIndex}
      onTabChange={(e) => onTabChange?.({ index: e.index })}
      onTabClose={(e) =>
        handleTabClose?.({
          ...e,
          closedTab: tabs[e.index],
        })
      }
      className={tabViewClassNames}
    >
      {tabs.map((tab, index) => (
        <TabPanel
          key={tab.id || index}
          header={tab.header}
          closable={tab.closable}
          className={classNames}
          headerTemplate={tab.headerTemplate}
        >
          {tab.content}
        </TabPanel>
      ))}
    </TabView>
  );
};

export default REITab;
